export const STATUS_KEY = "mobile_app_banner_status";
